import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Injectable()
@Pipe({
    name: 'excludeInformationItems',
    standalone: false
})
export class ExcludeInformationItemsPipe implements PipeTransform {
    public transform(items: any[], excludeNames: string[]): any[] {
        excludeNames = excludeNames || [];
        items = items.filter((ii) => excludeNames.indexOf(ii.name) < 0);
        return items;
    }
}
